import { FunctionComponent } from 'react';
import styles from "./ContentManagementCard.module.css";
import cn from 'classnames';
import {Image, Card, Dropdown} from 'react-bootstrap';
import { ASSESTS } from '../../../constant/assest';
import { getColorForUser } from '../../common/UserCard/UserCard';
import LocalStorageService, { LocalStorageKeys } from '../../../services/localStorageService';
import { categoryOptions } from '../../../pages/unAuth/ListIcons/component/UploadNewContent/UploadNewContent';
import { UserType, IManagementStatus } from "../../../constant/enums";
import {User} from '../../../redux/slices/auth/types';

interface IContentManagementCardProps {
    title: string;
    summary: string;
    bannerFile: string;
    status: string;
    category: string | null;
    content_type: string;
    userImage: string;
    userId: string;
    userName: string;
    likeCount?: number;
    shareCount?: number;
    onView: () => void;
    onDelete: () => void;
    onApprove: () => void;
    onReject: () => void;
    className?: string;
};

const isVideo = (url: any) => {
  const videoExtensions = ['mp4', 'mov', 'webm', 'mkv', 'avi'];
  const ext = url.split('?')[0].split('.').pop().toLowerCase();  
  return videoExtensions.includes(ext);
};

const getCategoryLabel = (value: string | null) => {
    const option = categoryOptions.find(opt => opt.value === value);
    return option ? option.label : value;
};

const ContentManagementCard: FunctionComponent<IContentManagementCardProps> = ({ bannerFile, status, title, summary, category, content_type, userImage, userId, userName, likeCount, shareCount, onView, onDelete, onApprove, onReject, className }) => {
    const bgColor = getColorForUser(userName || 'N/A');
    const user = LocalStorageService.get<User >(LocalStorageKeys.USER);    
     const isSuperAdmin = user?.role === UserType.SUPER_ADMIN;
    
    return (
        <Card className={cn(styles.contentManagementCard, className)}>
            <Card.Header bsPrefix={styles.contentListCardHeader}>
                <span className={cn(styles.status, styles[status || ''])}>
                    <Image src={status === IManagementStatus.REJECTED ? ASSESTS.REJECT : ASSESTS.REVIEW} alt='In Review' width={12} height={12} /> {status === IManagementStatus.INREVIEW ? 'In Review' : 
                     status === IManagementStatus.PUBLISHED ? 'Published' : status === IManagementStatus.DRAFT ? 'Draft' : 'Rejected'
                    }
                </span>
                { isVideo(bannerFile) ? (
                        <video src={bannerFile} controls muted className={styles.contentListCardImg} />
                    ) : (
                        <Card.Img
                            src={bannerFile ? bannerFile : ASSESTS.CONTENTIMAGEPLACEHOLDER}
                            onError={(e) => (e.currentTarget.src = ASSESTS.CONTENTIMAGEPLACEHOLDER)}
                            alt={title}
                            bsPrefix={styles.contentListCardImg}
                        />
                    )
                }
            </Card.Header>
            <Card.Body bsPrefix={styles.contentListCardBody}>
                <div className={styles.options}>
                    <span className={styles.tag}>
                        {/* <Image src={category === 'fishinity_pro_center' ? ASSESTS.FISHNITYPROCENTRETAG : category === 'locating_app_action' ? ASSESTS.LOCATINGAPPACTION : category === 'upload' ? ASSESTS.UPLOAD : ""} alt='' width={16} height={16} />  */}
                         {getCategoryLabel(category)}
                    </span>
                    <Dropdown className={styles.dropdown}>
                        <Dropdown.Toggle variant='light' className={styles.dropdownBtn}>
                            <Image src={ASSESTS.THREEDOT} alt='Option' width={30} height={30} />
                        </Dropdown.Toggle>
                        <Dropdown.Menu className={styles.listIconDopdown}>
                            <div className={styles.listIconDopdownBody}>
                                <Dropdown.Item bsPrefix={styles.listIconDopdownItem} onClick={onView}><Image src={ASSESTS.VIEWICONLIST} alt='View Details' width={26} height={24} /> View Details</Dropdown.Item>
                                {isSuperAdmin  && (
                                    <>
                                        {status !== IManagementStatus.PUBLISHED && status !== IManagementStatus.REJECTED && (
                                            <>
                                                <Dropdown.Item bsPrefix={styles.listIconDopdownItem} onClick={onApprove}><Image src={ASSESTS.APPROVEICONLIST} alt='Approve' width={26} height={24} /> Approve</Dropdown.Item>
                                                {/* <Dropdown.Item bsPrefix={cn(styles.listIconDopdownItem, styles.logoutBtn)} onClick={onReject}><Image src={ASSESTS.REJECTICONLIST} alt='Reject' width={26} height={24} /> Reject</Dropdown.Item> */}
                                            </>
                                        )}
                                     <Dropdown.Item bsPrefix={cn(styles.listIconDopdownItem, styles.logoutBtn)} onClick={onDelete}><Image src={ASSESTS.DELETEICONLIST} alt='Delete' width={26} height={24} /> Delete</Dropdown.Item>
                                    </>
                                )}
                                { status === IManagementStatus.DRAFT && user?.role === UserType.SUB_ADMIN && user.id === userId && (
                                    <Dropdown.Item bsPrefix={styles.listIconDopdownItem} onClick={onApprove}><Image src={ASSESTS.APPROVEICONLIST} alt='Approve' width={26} height={24} /> Approve</Dropdown.Item>
                                )}
                            </div>
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
                <div className={styles.detail}>
                    <Card.Title as={'div'} bsPrefix={styles.title}>{title}</Card.Title>
                    <Card.Text as={'div'} bsPrefix={styles.text}>{summary}</Card.Text>
                </div>
                <div className={styles.meta}>
                    <div className={styles.user}>
                        <div className={cn(styles.userImage, !userImage && styles.userAvatarText)}
                            style ={!userImage ? { backgroundColor: bgColor } : undefined}>
                            {userImage ? 
                            <Image src={userImage} alt={userName} width={33} height={33}/> : 
                            (userName ? userName.trim()?.charAt(0).toUpperCase() : '?')
                        }                   
                        </div>
                        <div className={styles.userName}>{userName} {content_type=== 'sponsored' && <span>(sponsored)</span>}</div>
                    </div>
                    <div className={styles.shares}>
                        <div className={styles.like}>
                            <Image src={ASSESTS.LIKE} alt='Like' width={12} height={12} /> {likeCount ? likeCount : 0}
                        </div>
                        <div className={styles.share}>
                            <Image src={ASSESTS.SHARE} alt='Share' width={12} height={12} /> {shareCount ? shareCount : 0}
                        </div>
                    </div>
                </div>
            </Card.Body>
        </Card>
    );
};

export default ContentManagementCard;

